const mobileYPadding = 5
const mobileXPadding = 3

export { mobileYPadding, mobileXPadding }
